import React from 'react'

// set default size to 10px
export default function Spacer({ size = 100 }) {
  return <div style={{ height: size }} />
}
